import { render, staticRenderFns } from "./qrcode-invite.vue?vue&type=template&id=b3b35986&"
import script from "./qrcode-invite.vue?vue&type=script&lang=js&"
export * from "./qrcode-invite.vue?vue&type=script&lang=js&"
import style0 from "./qrcode-invite.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports